import HighscoreView from "./view";
import HighscoreUpdater from "./updater";
export { HighscoreView, HighscoreUpdater };